import React, { useState, useEffect, useRef } from 'react';
import './InfoUser.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faChevronDown, faSignOutAlt, faCog } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../../url';

export default function InfoUser() {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        fetch(`${baseURL}/userLogued.php`)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                setUsuario(data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al obtener datos:', error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setModalOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleLogout = async () => {
        try {
            const response = await fetch(`${baseURL}/logout.php`, { method: 'GET' });
            if (response.ok) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error:', error.message);
        }
    };

    if (loading) {
        return (
            <div className="infoUser">
                <div className="infoUser__trigger">
                    <div className="infoUser__avatar infoUser__avatar--loading" />
                </div>
            </div>
        );
    }

    const initials = usuario.nombre
        ? usuario.nombre.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
        : '?';

    return (
        <div className="infoUser" ref={modalRef}>
            <button
                className={`infoUser__trigger ${modalOpen ? 'infoUser__trigger--active' : ''}`}
                onClick={() => setModalOpen(!modalOpen)}
            >
                <div className="infoUser__avatar">
                    {usuario.imagen ? (
                        <img src={usuario.imagen} alt={usuario.nombre} />
                    ) : (
                        <span>{initials}</span>
                    )}
                </div>
                <span className="infoUser__name">{usuario.nombre?.slice(0, 16)}</span>
                <FontAwesomeIcon icon={faChevronDown} className={`infoUser__chevron ${modalOpen ? 'infoUser__chevron--open' : ''}`} />
            </button>

            {modalOpen && (
                <div className="infoUser__modal">
                    <div className="infoUser__modalHeader">
                        <div className="infoUser__modalAvatar">
                            {usuario.imagen ? (
                                <img src={usuario.imagen} alt={usuario.nombre} />
                            ) : (
                                <span>{initials}</span>
                            )}
                        </div>
                        <div className="infoUser__modalInfo">
                            <h4>{usuario.nombre}</h4>
                            <span>{usuario.email}</span>
                            <span className="infoUser__rol">{usuario.rol}</span>
                        </div>
                    </div>

                    <div className="infoUser__modalDivider" />

                    <div className="infoUser__modalActions">
                        <Anchor to="/dashboard/usuarios" className="infoUser__modalAction" onClick={() => setModalOpen(false)}>
                            <FontAwesomeIcon icon={faCog} />
                            Mi perfil
                        </Anchor>
                        <button className="infoUser__modalAction infoUser__modalAction--danger" onClick={handleLogout}>
                            <FontAwesomeIcon icon={faSignOutAlt} />
                            Cerrar sesión
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}